import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ContactosService } from '../../services/contactos.service';

@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.scss']
})
export class ContactosComponent implements OnInit {
  searchControl = new FormControl('');
  contactosOriginal: any[] = []; // Todos los contactos
  contactosFiltrados: any[] = []; // Los que se muestran según el filtro
  gridApi: any;

  columnDefs = [

    {
      headerName: '',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      colId: 'checkbox',
      width: 40,
      suppressFilter: true,
      suppressSorting: true,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },

    { headerName: 'Nombre', field: 'nombre' },
    { headerName: 'Email', field: 'email' },
    { headerName: 'Teléfono', field: 'telefono' }
  ];

  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };

  prescriptorId: any;
  contactosSeleccionados: any;
  seleccionadosSet = new Set<number>();
  seleccionInicialCargada = false;

  constructor(
    public dialogRef: MatDialogRef<ContactosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private contactosService: ContactosService
  ) { }

  ngOnInit() {
    const contactosYaSeleccionados = this.contactosSeleccionados || [];
    this.seleccionadosSet = new Set(contactosYaSeleccionados.map(c => c.id));

    this.contactosService.getContactos().subscribe(contactos => {
      this.contactosOriginal = contactos || [];
      this.aplicarFiltro(this.searchControl.value || '');
    });

    this.searchControl.valueChanges.subscribe((value: string) => {
      this.aplicarFiltro(value || '');
    });
  }

  aplicarFiltro(filtro: string) {
    const lower = filtro.toLowerCase();
    this.contactosFiltrados = this.contactosOriginal.filter(c =>
      c.nombre.toLowerCase().includes(lower) ||
      c.email.toLowerCase().includes(lower) ||
      c.telefono.toLowerCase().includes(lower)
    );

    if (this.gridApi) {
      this.gridApi.setRowData(this.contactosFiltrados);
      setTimeout(() => this.marcarSeleccionados(), 0);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    // Mostrar datos y marcar los seleccionados
    this.gridApi.setRowData(this.contactosFiltrados);
    setTimeout(() => this.marcarSeleccionados(), 0);

    setTimeout(() => {
      this.seleccionInicialCargada = true;
    }, 0);
  }


  onCellClicked(event: any) {
    const contacto = event.data;
    const seleccionado = event.node.isSelected();

    if (seleccionado) {
      this.seleccionadosSet.add(contacto.id);
    } else {
      this.seleccionadosSet.delete(contacto.id);
    }

    if (this.prescriptorId !== null && this.prescriptorId !== undefined && this.prescriptorId !== '') {
      if (seleccionado) {
        this.contactosService.postPrecriptorContacto(contacto, this.prescriptorId).subscribe(x => {
          console.log('guardado');
        });
      } else {
        this.contactosService.deletePrescriptoContacto(contacto.id, this.prescriptorId).subscribe(x => {
          console.log('eliminado');
        });
      }
    }
  }


  onSelectionChanged() {
    const seleccionados = this.gridApi.getSelectedRows();
    const idsSeleccionados = new Set<number>(seleccionados.map(c => c.id));

    // Añadir los nuevos
    for (const id of idsSeleccionados) {
      this.seleccionadosSet.add(id);
    }

    // Eliminar los que ya no están seleccionados y que están en la vista actual
    for (const contacto of this.contactosFiltrados) {
      if (!idsSeleccionados.has(contacto.id)) {
        this.seleccionadosSet.delete(contacto.id);
      }
    }
  }

  marcarSeleccionados() {
    if (!this.gridApi) return;

    this.gridApi.forEachNode(node => {
      if (this.seleccionadosSet.has(node.data.id)) {
        node.setSelected(true);
      }
    });
  }

  confirmarSeleccion() {
    const seleccionados = this.contactosOriginal.filter(c => this.seleccionadosSet.has(c.id));
    this.dialogRef.close(seleccionados);
  }

}

